import { apiClient } from '../client';
const ENDPOINTS = {
    TEMPLATES: '/templates',
    UPLOAD: '/templates/upload',
};
export const templatesService = {
    // Get all templates (returns array directly)
    getTemplates: () => apiClient.get(ENDPOINTS.TEMPLATES),
    // Get templates by category (returns array directly)
    getTemplatesByCategory: (category) => apiClient.get(`${ENDPOINTS.TEMPLATES}?category=${category}`),
    // Upload templates (returns single template)
    uploadTemplates: (formData) => apiClient.post(ENDPOINTS.UPLOAD, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }),
    // Get download URL
    getDownloadUrl: (id) => apiClient.get(`${ENDPOINTS.TEMPLATES}/${id}/download`),
    // Delete template
    deleteTemplate: (templateId) => apiClient.delete(`${ENDPOINTS.TEMPLATES}/${templateId}`),
};
